import React, { useEffect } from 'react'
import AdditionalServices from './AdditionalServices'
import ProductConfigurationsTable from './ProductConfigurationsTable'
import { OrderDetails } from './OrderDetails'
import { Modifications, NGSOTypeOptions } from '../enum'

export const NgsoTubes = (props) => {
  const {
    sessionData,
    handlePrev,
    saveSessionHandler,
    productDetails,
    productInformation,
    totalValidation,
    clearSession,
    configuratorAddToMiniCart,
  } = props
  const [additionalServices, setAdditionalServices] = React.useState<any[]>([])
  const product = sessionData.length
    ? sessionData[0]?.wellList?.length
      ? sessionData[0]?.wellList[0]
      : {}
    : {}

  useEffect(() => {
    if (product.additionalServices)
      setAdditionalServices(product.additionalServices)
  }, [product])

  const updateSessionData = (data: any, key: string, concentration: string) => {
    const wellList = sessionData[0].wellList?.map((item) => {
      const tmpWellList = item
      tmpWellList[key] = data
      if (
        key === 'ngsoType' &&
        productDetails.isCSR &&
        sessionData[0].wellList[0].format !== Modifications.Dry
      ) {
        if (data === NGSOTypeOptions.NGSOGold) {
          tmpWellList['concentration'] = concentration
        } else {
          tmpWellList['concentration'] = '100'
        }
      }
      return tmpWellList
    })
    const tmpSessionData = [...sessionData]
    tmpSessionData[0]['wellList'] = wellList
    saveSessionHandler(tmpSessionData, true)
  }

  const onSelectNgsoType = (type: string, concentration: string) => {
    updateSessionData(type, 'ngsoType', concentration)
  }

  const handleAdditionalServicesCheck = ({ target: { checked, value } }) => {
    const tempAdditionalServices = additionalServices.length
      ? [...additionalServices]
      : []
    if (checked) {
      tempAdditionalServices.push(value)
    } else {
      const selectedIndex = additionalServices.findIndex(
        (item) => item === value
      )
      if (selectedIndex !== -1) {
        tempAdditionalServices.splice(selectedIndex, 1)
      }
    }
    setAdditionalServices(tempAdditionalServices.sort())
    updateSessionData(
      tempAdditionalServices.sort(),
      'additionalServices',
      sessionData[0].wellList[0].concentration
    )
  }

  const saveCOA = ({ target: { checked, value } }) => {
    sessionData.forEach((data) => {
      data.wellList.forEach((well) => {
        if (checked) {
          well.certificateOfAnalysis = value
        } else {
          well.certificateOfAnalysis = ''
        }
      })
    })
    saveSessionHandler(sessionData, true)
  }

  const saveHPLC = ({ target: { checked, value } }) => {
    sessionData.forEach((data) => {
      data.wellList.forEach((well) => {
        if (checked) {
          well.analyticalHPLC = value
        } else {
          well.analyticalHPLC = ''
        }
      })
    })
    saveSessionHandler(sessionData, true)
  }

  return (
    <>
      <ProductConfigurationsTable
        product={product}
        onSelectNgsoType={onSelectNgsoType}
        sessionData={sessionData}
        productDetails={productDetails}
      />
      <AdditionalServices
        handleCheck={handleAdditionalServicesCheck}
        product={product}
        saveCOA={saveCOA}
        saveHPLC={saveHPLC}
        productDetails={productDetails}
      />
      <OrderDetails
        handlePrev={handlePrev}
        orderItems={sessionData[0]?.wellList}
        sessionData={sessionData}
        productInformation={productInformation}
        product={product}
        additionalServices={additionalServices}
        saveSessionHandler={saveSessionHandler}
        productDetails={productDetails}
        clearSession={clearSession}
        totalValidation={totalValidation}
        configuratorAddToMiniCart={configuratorAddToMiniCart}
      />
    </>
  )
}

export default NgsoTubes
